import storage from '../utils/storage';
import axios from 'axios';
// Update the BaseURL to use HTTPS
const BaseURL = process.env.REACT_APP_BASE_URL;

// Helper to get token
const getToken = async () => {
  try {
    const token = await storage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }
    return token;
  } catch (error) {
    throw new Error('Failed to retrieve token');
  }
};

// General API request function with token handling
const apiRequest = async (url, method = 'GET', data = {}) => {
  const token = await getToken();
  console.log('token==>', token)
  try {
    const response = await axios({
      method,
      url: `${BaseURL}${url}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data || 'Something went wrong');
  }
};

// Login API
export const Login = (credentials) => {
  return axios.post(`${BaseURL}users/login`, credentials);
};

// Register API
export const Register = (userData) => {
  return axios.post(`${BaseURL}users/register`, userData);
};

// Verify Token API
export const verifyToken = async () => {
  // const token = await getToken();
  return apiRequest('users/verifyToken', 'GET');
};

// Get User Details API
export const getUserDetail = async () => {
  return apiRequest('users/userDetail', 'GET');
};

// Get all users
export const getAllUser = async () => {
  return apiRequest('userApp/users/getAllUsers', 'GET');
};

// Update Token API
export const updateToken = async (data) => {
  return apiRequest('users/updateToken', 'POST', data);
};

// Update Profile API
export const updateProfile = async (data) => {
  return apiRequest('users/updateProfile', 'POST', data);
};

// Change Password API
export const changePassword = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'users/changePass', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
};

// Forget Password API
export const forgetPassword = async (data) => {
  return axios.post(`${BaseURL}users/request-reset-otp`, data);
};

// Reset Password API
export const resetPassword = async (data) => {
  return axios.post(`${BaseURL}users/reset-password`, data);
};

// Verify Reset Token API
export const verifyResetToken = async (data) => {
  return axios.post(`${BaseURL}users/verify-reset-otp`, data);
};

// Verify Number API
export const verifyNumber = async (data) => {
  return apiRequest('users/verifyNumber', 'POST', data);
};

// Get All Venue Facilities
export const getAllVenueFacilities = async () => {
  return apiRequest('venueFacilities', 'GET');
};

// Get Location API
export const getLocation = () => {
  return axios.get('https://ipinfo.io/country');
};

// Facility APIs
export const getAllFacilities = async () => {
  return apiRequest('facility/get', 'GET');
};

// Get facility daily report
export const getFacilityDailyReport = async (facilityId, date) => {
  return apiRequest('dashboard/facility-daily-report', 'POST', {
    facility: facilityId,
    date: date
  });
};

export const AddNewFacility = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'facility/add', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
};

export const EditNewFacility = async (data) => {
  const token = await storage.getItem("token")
  // Ensure we're sending the exact field names from the database
  const payload = {
    id: data._id,  // Changed from id to _id
    ...data  // Rest of the fields will come from the getChangedFields function
  };
  return axios.post(BaseURL + 'facility/edit', payload, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

export const deleteFacility = async (facilityId) => {
  const token = await storage.getItem("token");
  return axios.delete(`${BaseURL}facility/delete/${facilityId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Get All Sports
export const getAllSports = async () => {
  const token = await storage.getItem("token");
  return axios.get(`${BaseURL}sports`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Get All Slots
export const getAllSlots = async () => {
  return apiRequest('slots', 'GET');
};

export const getAllBookings = async () => {
  return apiRequest('booking', 'GET');

};


export const getAllPitches = async () => {
  return apiRequest('pitch/get', 'GET', null, true); // assuming `true` tells it to attach token
};

// Pitch APIs
export const addPitch = async (pitchData) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}pitch/add`, pitchData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getPitches = async () => {
  const token = await storage.getItem("token");
  return axios.get(`${BaseURL}pitch/get`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const editPitch = async (pitchData) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}pitch/edit`, pitchData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const deletePitch = async (pitchId) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}pitch/del`, { id: pitchId }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const addNewPitch = async (pitchData) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}pitch/add`, pitchData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const saveSlot = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(BaseURL + 'slots/add', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Dashboard APIs
export const GetReports = async () => {
  const token = await storage.getItem("token");
  return axios.get(BaseURL + 'dashboard/myReports', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getReportByDate = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(BaseURL + 'dashboard/reportByDate', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getReportBySport = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(BaseURL + 'dashboard/reportBySports', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getReportByFacility = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(BaseURL + 'dashboard/reportByFacility', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getReportByFacilityAndSports = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(BaseURL + 'dashboard/reportByFacilitySport', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Facility Report APIs
export const getFacilityReport = async (facilityId) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}dashboard/reportByFacility`,
    { facility: facilityId },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};

export const getFacilityReportByDate = async (facilityId, startDate, endDate) => {
  const token = await storage.getItem("token");
  return axios.get(`${BaseURL}dashboard/facility/${facilityId}/date`, {
    params: { startDate, endDate },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getFacilityReportBySport = async (facilityId, sportId) => {
  const token = await storage.getItem("token");
  return axios.get(`${BaseURL}dashboard/facility/${facilityId}/sport/${sportId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getFacilityReportBySportAndDate = async (facilityId, sportId, startDate, endDate) => {
  const token = await storage.getItem("token");
  return axios.get(`${BaseURL}dashboard/facility/${facilityId}/sport/${sportId}/date`, {
    params: { startDate, endDate },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Get slots by date - map to existing endpoint if available
export const getSlotsByDate = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}slots/webapp/getByDate`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Block slot - you might need to adjust the endpoint
export const blockSlot = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}slots/block`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

// Unblock slot - you might need to adjust the endpoint
export const unBlock = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}slots/unBlock`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const editSlot = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'slots/edit', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

// Edit slot price - you might need to adjust the endpoint
export const editIndividual = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}slots/editIndividual`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const editPitchService = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'pitch/edit', {
    id: data._id,
    name: data.name,
    maxPlayers: data.maxPlayers
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const ContactUs = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'contact', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

// Comprehensive Revenue Report API
export const getComprehensiveReport = async (filters) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}dashboard/comprehensive-revenue-report`, filters, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

export const getSlotBookingDetails = async (slotId, fromTime) => {
  try {
    const token = await storage.getItem("token");
    const response = await axios.post(`${BaseURL}slots/${slotId}`, {
      from_date: fromTime
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching slot booking details:', error);
    throw error;
  }
};

// Venue Facilities APIs
export const addVenueFacility = async (data) => {
  return apiRequest('venueFacilities', 'POST', data);
};

// Delete parent slot
export const deleteParentSlot = async (slotId) => {
  try {
    const response = await axios.delete(`${BaseURL}slots/deleteParentSlot/${slotId}`, {
      headers: {
        Authorization: `Bearer ${await getToken()}`
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSlotDetailIndex = async (detailSlotId, detailIndex) => {
  try {
    const response = await axios.delete(`${BaseURL}slots/deleteSlotDetailIndex`, {
      data: { detailSlotId, detailIndex },
      headers: {
        Authorization: `Bearer ${await getToken()}`
      }
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllConvo = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'conversation/webApp/get', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const getMessages = async (conversationId) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'messages/webApp/get', { conversationId }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const sendWebMessage = async (data) => {
  const token = await storage.getItem("token")
  return axios.post(BaseURL + 'messages/webApp/', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

// Update the cancelSpecificBooking API function with auth headers
export const cancelSpecificBooking = async (detailSlotId, detailIndex, cancelReason, isMultiBooking = false) => {
  try {
    const token = await storage.getItem('token');
    console.log('token==>', token)

    let payload;
    if (isMultiBooking) {
      // For multi-booked slots, first arg is bookingId, third arg is cancelReason
      payload = {
        bookingId: detailSlotId,
        cancelReason: cancelReason
      };
    } else {
      // For regular slots, use the original format
      payload = {
        detailSlotId,
        detailIndex,
        cancelReason
      };
    }

    const response = await axios.post(`${BaseURL}slots/cancelSpecificBooking`, payload, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// NEW: Explicit API for multi-slot cancellation via dedicated endpoint
export const cancelMultipleSlots = async (bookingId, cancelReason) => {
  try {
    const token = await storage.getItem('token');
    const payload = { bookingId, cancelReason };
    const response = await axios.post(`${BaseURL}slots/cancelMultipleSlots`, payload, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const reserveSlotExistingUser = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}slots/reserveSlotExistingUser`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const reserveSlotRandomUser = async (data) => {
  const token = await storage.getItem("token");
  return axios.post(`${BaseURL}slots/reserveSlotRandomUser`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Search user by identifier or email
export const searchUser = async (identifier = null, email = null) => {
  try {
    const token = await storage.getItem("token");

    let url = `${BaseURL}userApp/users/searchUser/?`;

    if (identifier) {
      url += `identifier=${identifier}`;
    }

    if (email) {
      url += `email=${email}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

// Facility Reviews API
export const getFacilityReviews = async (facilityId, page = 1, limit = 10) => {
  try {
    const token = await storage.getItem("token");
    const response = await axios.get(`${BaseURL}facility/reviews/${facilityId}?page=${page}&limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Business Notifications API
export const getBusinessNotifications = async (page = 1, limit = 10) => {
  try {
    const token = await storage.getItem("token");
    const response = await axios.get(`${BaseURL}notification/get?page=${page}&limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Update notification status API
export const updateNotificationStatus = async (notificationId) => {
  try {
    const token = await storage.getItem("token");
    const response = await axios.put(`${BaseURL}notification/update-status`,
      { notificationId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Mark all notifications as read API
export const markAllNotificationsAsRead = async () => {
  try {
    const token = await storage.getItem("token");
    const response = await axios.put(`${BaseURL}notification/mark-all-read`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const markConversationAsRead = async (conversationId) => {
  try {
    const token = await storage.getItem("token");
    const response = await axios.post(
      `${BaseURL}conversation/webApp/markAsRead`,
      { conversationId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Dashboard Analytics API
export const getDashboardData = async (filters = {}) => {
  try {
    const token = await storage.getItem("token");
    const queryParams = new URLSearchParams();

    // Add filters to query parameters
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.facility) queryParams.append('facility', filters.facility);
    if (filters.sport) queryParams.append('sport', filters.sport);
    if (filters.pitch) queryParams.append('pitch', filters.pitch);

    // const url = `${BaseURL}analytics/dashboard-data${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const url = `${BaseURL}dashboard/mongo-dashboard-data${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Booking Details API
export const getBookingDetails = async (filters = {}, pagination = {}) => {
  try {
    const token = await storage.getItem("token");
    const queryParams = new URLSearchParams();

    // Add filters to query parameters
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.facility) queryParams.append('facility', filters.facility);
    if (filters.sport) queryParams.append('sport', filters.sport);
    if (filters.pitch) queryParams.append('pitch', filters.pitch);
    if (filters.period) queryParams.append('period', filters.period);

    // Add pagination parameters
    if (pagination.page) queryParams.append('page', pagination.page);
    if (pagination.limit) queryParams.append('limit', pagination.limit);

    // const url = `${BaseURL}analytics/booking-details${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const url = `${BaseURL}dashboard/mongo-booking-details${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const getAllBookingDetails = async (filters = {}) => {
  try {
    const token = await storage.getItem("token");
    const queryParams = new URLSearchParams();

    // Add filters to query parameters
    // Correct mapping based on what clean(filters) returns
    if (filters.period) queryParams.append('period', filters.period);
    if (filters.facility) queryParams.append('facility', filters.facility);
    if (filters.sport) queryParams.append('sport', filters.sport);
    if (filters.pitch) queryParams.append('pitch', filters.pitch);

    // Only send startDate/endDate for custom period
    if (filters.period === 'custom') {
      if (filters.startDate) queryParams.append('startDate', filters.startDate);
      if (filters.endDate) queryParams.append('endDate', filters.endDate);
    }


    // const url = `${BaseURL}analytics/booking-details-withoutPagination${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const url = `${BaseURL}dashboard/mongo-booking-details-without-pagination${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createConversation = async (data) => {
  const token = await storage.getItem("token")// or however you store token in web
  return axios.post(BaseURL + 'conversation/webApp/create', data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

